import React from 'react';
import { Article } from '@youhelp-ru/ui';
import { Typography } from '@cp/ds/src/components/typography';
import { Box } from '@cp/ds/src/components/box';
import { WithUpperline } from '@cp/ds/src/components/withUpperline';
import { RoutedLink as Link } from 'src/shared/ui/link';

export const PaymentPolicyWidget = () => (
  <Article>
    <Typography component="h2" sx={{ typography: { xs: 'h4', md: 'h2' }, my: { xs: 2.75, md: 6 } }}>
      Оплата и возврат
    </Typography>
    <p>
      <b>Подписка</b> - это ежемесячный платёж, открывающий доступ к неограниченному числу заказов. Идеально для тех, кто обращается к сервису регулярно. Подписка продлевается автоматически каждый месяц. За сутки до очередного списания мы пришлём уведомление на вашу почту — при условии, что адрес был подтверждён при регистрации.
    </p>
    <br />
    <p>
      <b>Комиссия с заказа</b> - это разовый платёж. Оплата в размере 379 ₽ спишется только после того, как заказ будет успешно завершён. Вы платите исключительно за состоявшиеся услуги. Вариант подходит тем, кто пользуется сервисом время от времени или пока не уверен, удастся ли найти няню.
    </p>
    <br />
    <Box sx={{ mb: { xs: 5, md: 7 } }}>
      <Typography component="h4" sx={{ typography: { xs: 'h6', md: 'h3' }, m: 0, mb: { xs: 1, md: 2.5 } }}>
        Почему важно оформлять заказы через сайт?
      </Typography>
      <Typography component="span" variant="body bold">
        Только официальное оформление заказа даёт вам все преимущества сервиса:
      </Typography>
      <Typography component="ul" sx={{ mb: 2.5 }}>
        <Typography component="li">Гарантия бронирования — ваше время у выбранной няни фиксируется, и никто другой не сможет занять его на эти же часы.</Typography>
        <Typography component="li">Страховая защита — страховка действует исключительно для заказов, проведённых через YouHelp.</Typography>
        <Typography component="li">Поддержка в сложных ситуациях — мы можем оперативно помочь и урегулировать проблему, только если заказ был оформлен на сайте.</Typography>
      </Typography>
    </Box>
    <Box id="refund">
      <WithUpperline>
        <Typography component="h3" sx={{ typography: { xs: 'h6', md: 'h3' }, m: 0, mb: { xs: 1, md: 2.5 } }}>
          Как управлять подпиской: отмена, возврат и пауза
        </Typography>
      </WithUpperline>
      <p>
        Здесь собраны ответы на главные вопросы об оплате. Выберите свою ситуацию.
      </p>
      <br />
        <Typography component="h4" sx={{ typography: { xs: 'h6', md: 'h3' }, m: 0, mb: { xs: 1, md: 2.5 } }}>
          Как отменить подписку
        </Typography>
      <p>
        Чтобы избежать автоматического продления, перейдите в личный кабинет в раздел «Оплата» и нажмите «Отменить автопродление». После этого средства списываться не будут.
      </p>
      <br />
        <Typography component="h4" sx={{ typography: { xs: 'h6', md: 'h3' }, m: 0, mb: { xs: 1, md: 2.5 } }}>
          Подписка списалась, но я не планировала её использовать
        </Typography>
      <p>
        Подписка действует иначе, чем разовый платёж: она обновляется ежемесячно автоматически. Условия автоматического продления указаны в пользовательском соглашении, которое вы принимаете при регистрации. О каждом предстоящем списании мы предупреждаем письмом на почту.
      </p>
      <p>
        Мы знаем, что отключить подписку вовремя получается не всегда, поэтому обычно идём навстречу и возвращаем плату за последний месяц. Просто <Link href="/support/">напишите нам</Link> в чат техподдержки — мы во всём разберёмся.
      </p>
      <br />
        <Typography component="h4" sx={{ typography: { xs: 'h6', md: 'h3' }, m: 0, mb: { xs: 1, md: 2.5 } }}>
          Как вернуть деньги
        </Typography>
      <p>
        Чтобы оформить возврат за последний оплаченный месяц, <Link href="/support/">обратитесь</Link> к администратору. Деньги вернутся на счёт в срок до 10 рабочих дней. После оформления возврата рекомендуем сразу удалить карту в разделе «Оплата», чтобы предотвратить дальнейшие списания.
      </p>
      <p>
        Возврат возможен только за один последний месяц. Средства за более ранние периоды не возвращаются, так как в это время сервис был активен, а мы заранее уведомляли вас о каждом платеже.
      </p>
      <br />
        <Typography component="h4" sx={{ typography: { xs: 'h6', md: 'h3' }, m: 0, mb: { xs: 1, md: 2.5 } }}>
          Случилось двойное списание
        </Typography>
      <p>
        Если деньги списались дважды или платёж прошёл после удаления карты, пожалуйста, направьте письмо на почту admin@youhelp.ru. Обязательно приложите скриншоты с подтверждением двойной транзакции. Администратор проверит информацию и вернёт излишне списанную сумму.
      </p>
      <br />
        <Typography component="h4" sx={{ typography: { xs: 'h6', md: 'h3' }, m: 0, mb: { xs: 1, md: 2.5 } }}>
          Как поставить подписку на паузу
        </Typography>
      <p>
        Чтобы приостановить подписку, просто напишите в чат поддержки или ответьте на любое наше письмо фразой: «Хочу заморозить подписку». Менеджер поставит её на паузу, зафиксирует остаток и пришлёт подтверждение. Когда снова понадобится помощь няни — просто дайте нам знать.
      </p>
      <p>
        Минимальный срок одной активации или заморозки составляет 3 месяца.
      </p>
    </Box>
  </Article>
);
